module.exports = __webpack_public_path__ + "img/parter-work13.1f9a08ca.png";